import { Link } from "react-router-dom"
import "../../App.scss"

function Categories() {


    const categories = [
        {
            name: 'Food and Nutrition',
            class: 'catHomeOne',
        },
        {
            name: 'Grooming Supplies',
            class: 'catHomeTwo',
        },
        {
            name: 'Dental Care',
            class: 'catHomeThree',
        },
        {
            name: 'Medical Supplies',
            class: 'catHomeFour',
        },
        {
            name: 'Health and Wellness',
            class: 'catHomeFive',
        },
        {
            name: 'Toys and Entertainment',
            class: 'catHomeSix',
        },
        {
            name: 'Beds and Beddings',
            class: 'catHomeSeven',
        },
        {
            name: 'Collars, Leashes, and Harnesses',
            class: 'catHomeEight',
        }, {
            name: 'Apparel and Accessories',
            class: 'catHomeNine',
        },
        {
            name: 'Training and Behavior',
            class: 'catHomeTen',
        },
        {
            name: 'Tech for Pets',
            class: 'catHomeEleven',
        },
        {
            name: 'Outdoor and Adventure Gear',
            class: 'catHomeTwelve',
        },
        {
            name: 'Waste Management',
            class: 'catHomeThirteen',
        },
        {
            name: 'Pet Identification and Tracking',
            class: 'catHomeFourteen',
        },
        {
            name: 'Breeding and Reproduction',
            class: 'catHomeFifteen',
        }

    ]



    return (
        <div className="MainDiv">
            <div className="categories-main-box">
                <center>
                    <p className="heading">Categories</p>
                </center>

                <div className="home-category-box">

                    {
                        categories.map((c) => (
                            <Link to={{
                                pathname: "/shop",
                                search: `?catValue=${encodeURIComponent(c.name)}&searchValue=${encodeURIComponent("")}`
                            }}>
                                <div className={c.class}>

                                    <p className="catText" >{c.name}</p>


                                </div>
                            </Link>
                        ))
                    }


                </div>
            </div>
        </div>
    )
}

export default Categories